exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ticket_form_slider {\n  padding-left: 8px;\n}\n.ticket_form_slider .el-input-number {\n  line-height: 30px;\n  width: 130px;\n}\n.ticket_form_slider .el-input__inner {\n  text-align: center!important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c81bf9da","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/TicketFormRate.vue
// module id = 935
// module chunks = 75